import UserModel from "../model/user_model";

export const toUserModel = (object) => {
    const data = object.data ?? [];
    if (data.length === 0) {
        return null;
    }
    
    const id = data[0]._id ?? "";
    const name = data[0].name ?? "";
    const email = data[0].email ?? "";
    const tierId = data[0].tierId ?? "";
    const tier = data[0].tier ?? "";
    const videoCallTimeRemaining = data[0].addOns.videoCall ?? 0; //data[0].videoCallTimeRemaining ?? 0;
    const voiceCallTimeRemaining = data[0].addOns.voiceCall ?? 0; //data[0].voiceCallTimeRemaining ?? 0;
    const videoCallUsage = data[0].videoCallUsage ?? 0;
    const maxVideoCallTime = data[0].maxVideoCallTime ?? 0;
    const currentVideoCallUsage = data[0].currentVideoCallUsage ?? 0;
    const planExpirationDate = data[0].planExpirationDate ?? '';
    const messagingRemaining = data[0].messagingRemaining ?? "";
    return new UserModel({ id, name, email, tierId, tier, videoCallUsage, videoCallTimeRemaining, planExpirationDate, voiceCallTimeRemaining, messagingRemaining, maxVideoCallTime, currentVideoCallUsage });
};